import {Route} from '@angular/router';

import {JhiArchiveComponent} from './archive.component';

export const archiveRoute: Route = {
    path: 'archive',
  component: JhiArchiveComponent,
  data: {
    pageTitle: 'archive.title'
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/archive/archive.route.ts